module.exports = __webpack_public_path__ + "fde1e6806c63e74ceb19f8f31182f3ec.mp3";